import * as React from "react"
import { useStaticQuery, graphql, Script } from "gatsby"

const Seo = ({ description, title, children }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            twitterUsername
            image
          }
        }
      }
    `
  )

  const seo = {
    title: title
      ? `${title} | Infer`
      : site.siteMetadata?.title,
    description: description || site.siteMetadata.description,
    image: `${site.siteMetadata.siteUrl}${site.siteMetadata.image}`,
    siteUrl: site.siteMetadata.siteUrl,
    twitterUsername: site.siteMetadata.twitterUsername,
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta content="all" name="robots" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.siteUrl} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitterUsername} />
      <meta content="800" name="twitter:image:width" />
      <meta content="418" name="twitter:image:height" />
      <meta content="Infer Logo" name="twitter:image:alt" />

      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content="Infer" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.getinfer.io/" />
      <meta
        property="og:title"
        content="Predictive Analytics that integrates with your GTM"
      />
      <meta
        property="og:description"
        content="Infer enables RevOps and GTM teams to create bespoke machine learning models, turning messy data sources into predictive insights on churn, leads, forecasting, and more— all synced into their CRM, ad platform, or data warehouse."
      />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Infer Logo" />
      <meta property="og:see_also" content="https://github.com/inferlabs/" />
      <meta
        property="og:see_also"
        content="https://www.linkedin.com/company/learntoinfer/"
      />
      <meta property="og:see_also" content="https://twitter.com/learntoinfer" />
      <Script
        type="text/javascript"
        id="hs-script-loader"
        defer
        src="//js-eu1.hs-scripts.com/139761212.js"
      />
      {children}
    </>
  )
}

export default Seo
